
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NativeBridge } from '@portal/react-native-api';
@Component
export default class ImpressumPage extends Vue {
	private factory = new NativeBridge();
	private api = this.factory.getNativeApi();

	navigateTo(url: string): void {
		const { isAppView } = this.$store.state;

		if (isAppView) {
			this.api.openURL(url);
		} else {
			window.open(url, '_blank');
		}
	}
}
